/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DeviceRotatePortraitIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Device Rotate Portrait',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M36 15.084V8a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12.751a12.219 12.219 0 0 1 .333-2H6V8h24v7.085ZM4 17a1.023 1.023 0 0 1-1 1 1.022 1.022 0 0 1-1-1v-2a1.04 1.04 0 0 1 1-1 1.041 1.041 0 0 1 1 1Z"
    />
    <path
      d="m32.375 20.332 1.478-1.479A.49.49 0 0 0 34 18.5a.5.5 0 0 0-.5-.5h-5.052a.5.5 0 0 0-.447.447V23.5a.5.5 0 0 0 .5.5.488.488 0 0 0 .349-.148l1.506-1.506a6.018 6.018 0 0 1 2.144 5.6 6.075 6.075 0 1 1-8.123-6.615.976.976 0 0 0 .62-.921v-1.255a.76.76 0 0 0-.974-.723 8.919 8.919 0 0 0-6.451 8.552 9.021 9.021 0 0 0 8.645 8.937 8.891 8.891 0 0 0 6.154-15.589Z"
    />
  </svg>`;
};
